import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{appData.title}</h2>
            <div className="w-12 h-1 bg-primary-500 mx-auto lg:mx-0 mb-6 rounded-full"></div>
            <p className="text-foreground-600 text-sm md:text-base mb-6">{appData.description}</p>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {appData.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </div>
                  {feat}
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#" className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line"></i>
                App Store 下载
              </a>
              <a href="#" className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-android-line"></i>
                安卓版下载
              </a>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-64 max-w-full h-[420px] rounded-3xl overflow-hidden border-4 border-foreground-900/10 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=mobile%20phone%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20on%20screen%20warm%20cinematic%20lighting%20elegant%20UI%20design%20red%20and%20gold%20accents%20clean%20minimal%20layout%20modern%20smartphone%20mockup&width=500&height=900&seq=app-mockup&orientation=portrait"
                alt="妖精影院移动端界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}